import { createAction } from '@reduxjs/toolkit';
const GET_NEWS_EVENTS_ARTICLES_REQUEST = 'GET_NEWS_EVENTS_ARTICLES_REQUEST';
export const GET_NEWS_EVENTS_ARTICLES_SUCCESS = 'GET_NEWS_EVENTS_ARTICLES_SUCCESS';
const GET_NEWS_EVENTS_ARTICLES_FAILURE = 'GET_NEWS_EVENTS_ARTICLES_FAILURE';
const SET_GRID_TYPE = 'SET_GRID_TYPE';
const getNewsEventsArticlesRequest = createAction(GET_NEWS_EVENTS_ARTICLES_REQUEST);
const getNewsEventsArticlesSuccess = createAction(GET_NEWS_EVENTS_ARTICLES_SUCCESS, (payload, meta) => ({
    payload,
    meta,
}));
const getNewsEventsArticlesFailure = createAction(GET_NEWS_EVENTS_ARTICLES_FAILURE);
export const setGridType = createAction(SET_GRID_TYPE);
export const actions = {
    request: getNewsEventsArticlesRequest,
    success: getNewsEventsArticlesSuccess,
    failure: getNewsEventsArticlesFailure,
};
